<template>
    <div>
        <nav class="navbar" data-topbar role="navigation">
            <ul class="navbar-nav mr-auto">
                <li v-on:click="isOpen = !isOpen" v-if="this.$route.path == '/'">
                    <router-link to="/" class="long-link">{{ $t('navbar.korkeakoulu', currentLocale).toUpperCase() }}</router-link>
                </li>
                <li v-on:click="isOpen = !isOpen" v-if="this.$route.path != '/'">
                    <router-link :to="{path: '/' + currentLocale}">{{ $t('navbar.etusivu', currentLocale).toUpperCase() }}</router-link>
                </li>
            </ul>
            <img src="../../../static/icons/icon-menu.png" v-on:click="isOpen = !isOpen" class="d-md-none" id="open-close-menu" alt="Open and close menu">
            <ul id="mobile-menu" v-bind:class="{ closed: isOpen }" class="navbar-nav mobile-menu align-right">
                <li v-if="secretStore.isValid" v-on:click="isOpen = !isOpen" class="nav-dark">
                    <a href="#" v-on:click="secretStore.logout()">{{ $t('navbar.kirjauduulos', currentLocale).toUpperCase() }}</a>
                </li>
                <li v-on:click="isOpen = !isOpen" class="nav-dark">
                    <a v-if="secretStore.isValid" href="#" v-on:click="showModal">{{ $t('navbar.kirjautuneena', currentLocale).toUpperCase() }}</a>
                    <a v-else href="#" v-on:click="showModal">{{ $t('navbar.kirjaudu', currentLocale).toUpperCase() }}</a>
                </li>
                
                <li v-on:click="isOpen = !isOpen" class="link-info">
                    <router-link :to="{path: '/' + currentLocale + '/info'}">{{ $t('navbar.info', currentLocale).toUpperCase() }}</router-link>
                </li>
                <li v-on:click="isOpen = !isOpen">
                    <router-link :to="{path: '/' + currentLocale + '/opettajalle'}">{{ $t('navbar.opettajalle', currentLocale).toUpperCase() }}</router-link>
                </li>

                <li v-if="currentLocale !== 'es'" v-on:click="isOpen = !isOpen"><a href="/es">ES</a></li>
                <li v-if="currentLocale !== 'gl'" v-on:click="isOpen = !isOpen"><a href="/gl">GL</a></li>
                <li v-if="currentLocale !== 'ca'" v-on:click="isOpen = !isOpen"><a href="/ca">CA</a></li>
                <li v-if="currentLocale !== 'eu'" v-on:click="isOpen = !isOpen"><a href="/eu">EU</a></li>
            </ul>
        </nav>

        <Modal ref="loginModal"></Modal>
    </div>
</template>
<script>
  import secretStore from '../../utils/localstorage'
  import Modal from './Modal'

  export default {
    data: function() {
      return {
        modalShown: false,
        isOpen: true,
        secretStore
      }
    },
    components: {Modal},
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
        showCookieModal(){
            return window.localStorage.getItem('acceptcookies') != 'yes'
        },
    },
    methods: {
      showModal: function (e) {
        if(e){
            e.preventDefault();
        }
        this.$refs.loginModal.show()
      },
      checkCookieModal: function() {
        window.localStorage.setItem('acceptcookies', 'yes')
      },
      logout: function () {
        secretStore.logout()
      }
    },
  }
</script>
<style lang="scss">
    .navbar {
        background: #FFB84E;
        padding: 0 5rem 0 4rem;
        ul {
            background: #FFB84E;
            display: flex;
            flex-direction: row;
            li {
                padding: 0.5rem 0;
                margin-left: 1rem;
                span {
                    color: #d2963d;
                    font-size: 18px;
                    font-weight: bold;
                    text-decoration: none;
                }
                &.link-info {
                    margin-left: 3rem;
                }
                a {
                    color: #414141;
                    font-size: 18px;
                    font-weight: bold;
                    text-decoration: none;
                }
                &.nav-dark {
                    padding: 0.5rem 1rem;
                    background-color: #d2963d;
                }
            }
        }

        @media(max-width: 767.98px) {
            padding: 0.5rem 1rem;
            height:60px;
            ul {
                li {
                    margin-left:0;
                    .long-link {
                        font-size:14px;
                    }
                }
            }

            .mobile-menu {
                display: block;
                position: absolute;
                top: 60px;
                left: 0;
                right: 0;
                z-index: 99;
                li {
                    padding-left:1rem;
                    &.link-info {
                        margin-left:0rem;
                    }
                }
            }
            .closed {
                display:none;
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/views/components/Navbar.vue